import axios from '../utils/axios';
/**
 * 登录
 * @param  {[type]} data [description]
 * @return {[type]}      [description]
 */
export function getUserLogin(data) {
  return axios('/ttd-fund-user/userInfo/investorLogin', data);
}
/**
 * 关联的管理人
 * @param  {[type]} data [description]
 * @param  {[type]} au   [description]
 * @return {[type]}      [description]
 */
export function getUserRelationManager(data, au) {
  return axios('/ttd-fund-user/relation/invenstemManagerList', data, au);
}
/**
 * 个人信息
 * @param  {[type]} data [description]
 * @param  {[type]} au   [description]
 * @return {[type]}      [description]
 */
export function getManagerUserInfo(data, au) {
  return axios('/ttd-fund-user/relation/invenstemInManagerInfo', data, au);
}

/**
 * 发送验证短信  http://192.168.88.120:200/index.php?s=/17&page_id=432
 * @param {*} data
 * @param {*} au
 */
export function sendValidationSms(data, au) {
  return axios('/ttd-fund-user/organizationStructure/sendValidationSms', data, au);
}
